import dataLayer from '../../../assets/scripts/helpers/data-layer';

const $contactFormToggleSelect = $('.js-contact-select__select');
const $contactMarketToggleSelect = $('.js-contact-market__select');
const $submitbutton = $('.FormSubmitButton');

const changePageOnSelectChange = (e) => {
    const url = e.currentTarget.value;
    window.location = url;
};

const registerDataLayerSubmit = () => {
    if ($('.contact__form').length > 0 && $('.EPiServerForms').hasClass('ValidationSuccess')) {
        dataLayer.register('interaction', 'contact salesrep');
        dataLayer.register('eventAction', 'form_sent');
        window._satellite && window._satellite.track('action');
    }
};

const events = () => {
    $contactFormToggleSelect.on('change', changePageOnSelectChange);
    $contactMarketToggleSelect.on('change', changePageOnSelectChange);
    $submitbutton.on('click', registerDataLayerSubmit);
}

const init = () => {
    events();
}

export default init;
